"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_1 = __importDefault(require("../../styled"));
var automation_attribute_1 = __importDefault(require("../../_helpers/automation-attribute"));
var tokens_1 = require("../../tokens");
var icon_1 = __importDefault(require("../../atoms/icon"));
var SidebarLink = function (props) {
    return (React.createElement(SidebarLink.Element, __assign({ href: props.url, onClick: props.onClick, selected: props.selected }, automation_attribute_1.default('sidebar.link'), props),
        React.createElement(icon_1.default, { name: props.icon ? props.icon : 'arrow-right', size: 18, color: props.selected ? tokens_1.colors.icon.sidebarFocus : tokens_1.colors.icon.sidebar }),
        React.createElement("span", null, props.label)));
};
SidebarLink.Element = styled_1.default.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  cursor: pointer;\n  color: ", ";\n  text-decoration: none;\n  font-size: 13px;\n  line-height: 1;\n  padding: calc(", " / 2) 0;\n  margin-bottom: 10px;\n  &:hover\u00A0 {\n    color: ", ";\n    ", " path {\n      fill: ", ";\n    }\n  }\n  ", " {\n    margin-right: ", ";\n  }\n  span {\n    display: inline-block;\n    vertical-align: middle;\n  }\n"], ["\n  display: block;\n  cursor: pointer;\n  color: ", ";\n  text-decoration: none;\n  font-size: 13px;\n  line-height: 1;\n  padding: calc(", " / 2) 0;\n  margin-bottom: 10px;\n  &:hover\u00A0 {\n    color: ", ";\n    ", " path {\n      fill: ", ";\n    }\n  }\n  ", " {\n    margin-right: ", ";\n  }\n  span {\n    display: inline-block;\n    vertical-align: middle;\n  }\n"])), function (props) { return (props.selected ? tokens_1.colors.link.sidebarFocus : tokens_1.colors.link.sidebar); }, tokens_1.spacing.xsmall, tokens_1.colors.link.sidebarHover, icon_1.default.Element, tokens_1.colors.link.sidebarHover, icon_1.default.Element, tokens_1.spacing.xsmall);
SidebarLink.defaultProps = {};
exports.default = SidebarLink;
var templateObject_1;
//# sourceMappingURL=sidebar-link.js.map